import React, { useMemo, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

/**
 * Categorias como tags eliminables.
 *
 * No se usan checkboxes: la categoria se escribe (o se elige del datalist) y se
 * pulsa Agregar o Enter. Una categoria ya anadida no se puede volver a agregar,
 * asi que la lista no se duplica.
 */
export function CategoryTags({ value = [], options = [], onChange }) {
    const [draft, setDraft] = useState('');

    // Se ofrecen solo las que faltan; las ya elegidas no aparecen para evitar
    // volver a pickear algo que ya esta.
    const available = useMemo(
        () => options.filter(o => !value.includes(o)),
        [options, value]
    );

    const add = () => {
        const cat = draft.trim();
        if (!cat) return;
        if (value.includes(cat)) {
            setDraft('');
            return;
        }
        onChange([...value, cat]);
        setDraft('');
    };

    const remove = (cat) => onChange(value.filter(c => c !== cat));

    const onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            // Enter no debe disparar el submit del formulario.
            e.preventDefault();
            add();
        }
    };

    return (
        <div>
            <div className="d-flex gap-2">
                <input
                    className="form-control bg-dark text-white border-secondary py-2"
                    list="newsletter-categories"
                    placeholder="Escribe o elige una categoría y pulsa Enter"
                    value={draft}
                    onChange={e => setDraft(e.target.value)}
                    onKeyDown={onKeyDown}
                />
                <datalist id="newsletter-categories">
                    {available.map(o => <option key={o} value={o} />)}
                </datalist>
                <button type="button" className="btn btn-ink-outline" onClick={add} disabled={!draft.trim()}>
                    Agregar
                </button>
            </div>
            {value.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-2">
                    {value.map(c => (
                        <span key={c} className="badge-status status-on d-inline-flex align-items-center gap-2">
                            {c}
                            <button
                                type="button"
                                className="btn btn-sm p-0 border-0 text-white"
                                onClick={() => remove(c)}
                                aria-label={`Quitar ${c}`}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
}